import { generatePath } from 'react-router-dom';

import { PHR_ROUTES } from 'my-phr/const';
import { MANUAL_INPUT_TYPE } from 'my-phr/layout/modules/ManualInputs/const';

export function isNumeric(value) {
  return (
    (typeof value === 'number' ||
      (typeof value === 'string' && value.trim() !== '')) &&
    !isNaN(value)
  );
}

export function sanitizeCards(arr) {
  return arr.map((x, index) => ({
    id: x.id,
    name: x.name,
    cardType: x.cardType,
    type: x.type,
    orderNumber: index + 1,
  }));
}

//TODO use route constants
export function getLinkTo(card, sharedId, childId) {
  const basePath = Boolean(sharedId)
    ? generatePath(PHR_ROUTES.SHARING_VIEW_LINK, { id: sharedId })
    : PHR_ROUTES.ROOT;

  const cardLink = `${basePath}/details/${card.type.toLowerCase()}/${card.id}`;
  if (childId) return cardLink.concat(`/${childId}`);
  return cardLink;
}

export function isPanelWithMaxTwoNonExpandableSections(card) {
  const MAX_OBSERVATIONS_FOR_SMALL_PANEL = 2;
  const allObservations = card?.dashboardPreferenceDtos || [];

  const isRatioPanel = card?.storyblock?.fields?.some(
    (field) => field.inputType === MANUAL_INPUT_TYPE.RATIO.toLowerCase()
  );

  if (isRatioPanel) return true;

  if (allObservations.length > MAX_OBSERVATIONS_FOR_SMALL_PANEL) return false;

  return allObservations.every((observation) => {
    const items = observation?.items || [];

    if (items.length === 0) return false;

    const lastElement = items[items.length - 1];
    const isNonNumeric = isNaN(lastElement?.value);
    const isOnlyOne = items.length === 1;

    return isNonNumeric || isOnlyOne;
  });
}

export function getPanelHeight(isLongCard, hasRelatedTopic = true) {
  if (!isLongCard) {
    return hasRelatedTopic ? 'h-[205px]' : 'h-[264px]';
  }
  if (hasRelatedTopic) {
    return 'h-[545px]';
  } else {
    return 'h-[600px]';
  }
}
